// @flow

import styled from 'styled-components';
import Link from '../../../link';
import Chevron from './chevron.svg';
import { svgEncode } from '../../../../helpers';
import type { Theme } from '../../../../types';

const QuestionListItem = styled<typeof Link, Theme>(Link)`
  display: block;
  background: url('data:image/svg+xml;utf8,${svgEncode(Chevron)}') right 1.56em center no-repeat;
  background-color: ${props => props.theme.faq.questionList.backgroundColor};
  background-size: 1em auto;
  border-radius: 4px;
  color: ${props => props.theme.faq.questionList.question.color};
  font-weight: ${props => props.theme.faq.questionList.question.fontWeight};
  margin-bottom: 0.25rem;
  padding: 1rem 3rem 1rem 1rem;
  text-decoration: none;

  &:hover {
    background-color: ${props => props.theme.faq.questionList.backgroundColorHover};
  }
`;

export default QuestionListItem;
